import React, { useState } from "react";
import SimpleBarChart from "Samarth Module/components/Charts/SimpleBarChart.js";
import ArrowsOut from './../../../../assets/images/ArrowsOut.svg';
import ToggleButton from './../../../components/ToggleButton/ToggleButton.js';
import styles from './dispatchPriority.module.css';
import ExpandedModal from "Samarth Module/components/modal/ExpandedModal";

export default function BGPrioritization({ goodnessData, kpiSummaryData , dcWiseData, dcWiseKpiSummaryData}) {
    const [selectedView, setSelectedView] = useState('Goodness Improvement');
    const [expandedView, setExpandedView] = useState(false);
    // Handler for view change
    const handleViewChange = (selected) => {
        setSelectedView(selected);
    };

    // Handler for expanding the graph
    const handleExpand = () => {
        setExpandedView(prev => !prev);
    };

    const isPositive = (selectedView === 'Goodness Improvement' ? kpiSummaryData['Net improvement'] : dcWiseKpiSummaryData['Net improvement']) >= 0;

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p className={styles.title}>{selectedView}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <ToggleButton
                        options={['DC wise prioritization', 'Goodness Improvement']}
                        defaultSelected={selectedView}
                        onChange={handleViewChange}
                    />
                    <div className={styles.arrows_out}>
                    <img src={ArrowsOut} alt='Simple Bar Chart' height={16} width={16} onClick={handleExpand} />
                    </div>
                </div>
            </div>
            {/* {selectedView === "Goodness Graph" ? ( */}
            <>
                <div className={styles.aggregateDataContainer}>
                    {Object.keys(kpiSummaryData).map((item, index) => {
                        if (item !== 'Net improvement') {
                            return (
                                <div key={index} style={{ textAlign: 'center' }}>
                                    <p className={styles.dataLabel}>{item}</p>
                                    <span className={styles.dataValue}>{selectedView === 'Goodness Improvement' ? kpiSummaryData[item] : dcWiseKpiSummaryData[item]}</span>
                                </div>
                            )
                        }
                    })}
                    <div className={styles.netImprovementContainer}>
                        <p className={styles.netImprovementVal}>
                             {isPositive ? '↗' : '↘'}{selectedView === 'Goodness Improvement' ? kpiSummaryData['Net improvement'] : dcWiseKpiSummaryData['Net improvement']}%
                        </p>
                        <p className={styles.netImprovementTxt}>net improvement</p>
                    </div>
                </div>
                <SimpleBarChart view={selectedView} graphData={selectedView === 'Goodness Improvement' ? goodnessData : dcWiseData} />
            </>
            {expandedView && (
                <ExpandedModal onClose={handleExpand} open={expandedView} >
                    <div className={styles.modalContainer}>
                        <p className={styles.title} style={{ marginBottom: '2rem' }}>{selectedView}</p>
                        <div className={styles.aggregateDataContainer} style={{ width: '-webkit-fill-available' }}>
                            {Object.keys(selectedView === 'Goodness Improvement' ? kpiSummaryData : dcWiseKpiSummaryData).map((item, index) => {
                                if (item !== 'Net improvement') {
                                    return (
                                        <div key={index} style={{ textAlign: 'center' }}>
                                            <p className={styles.dataLabel}>{item}</p>
                                            <span className={styles.dataValue}>{selectedView === 'Goodness Improvement' ? kpiSummaryData[item] : dcWiseKpiSummaryData[item]}</span>
                                        </div>
                                    )
                                }
                            })}
                            <div className={styles.netImprovementContainer}>
                                <p className={styles.netImprovementVal}>
                                    {isPositive ? '↗' : '↘'}{selectedView === 'Goodness Improvement' ? kpiSummaryData['Net improvement'] : dcWiseKpiSummaryData['Net improvement']}%
                                </p>
                                <p className={styles.netImprovementTxt}>net improvement</p>
                            </div>
                        </div>
                        <SimpleBarChart graphData={selectedView === 'Goodness Improvement' ? goodnessData : dcWiseData} />
                    </div>
                </ExpandedModal>
            )}
        </>
    );
}